import { Injectable } from '@angular/core';
import { NavigationBehaviorOptions, NavigationExtras, Router, UrlTree } from '@angular/router';

/**
 * Stub implementation of Angular Router for a web component library.
 * Ensures navigation calls resolve to `true` since the host app controls routing.
 */

@Injectable({ providedIn: 'root' })
export class TellentClientRouterStub extends Router {
  public navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    return Promise.resolve(true);
  }

  public navigateByUrl(
    url: string | UrlTree,
    extras?: NavigationBehaviorOptions,
  ): Promise<boolean> {
    return Promise.resolve(true);
  }
}
